import React, { useContext } from "react";
import { PropertyListPageLayout } from "../../../../layouts";
import { ViewProvider } from "app/components/propertiesPage/context/ViewContext";
import { Context } from "services";

type PropertyListPageWrapperProps = {
  isFilterOpen: boolean;
  children: React.ReactNode;
  footerChildren: React.ReactNode;
  cities: any;
};

export const PropertyListPageWrapper: React.FC<
  PropertyListPageWrapperProps
> = ({ isFilterOpen, children, cities, footerChildren }) => {
  return (
    <>
      <div
        className={`transition-all duration-300 ${
          isFilterOpen ? "lg:ml-[250px]" : "ml-0"
        }`}
      >
        <PropertyListPageLayout cities={cities}>
          <ViewProvider>
            <div className="lg:px-customPadding px-4 w-full 2xl:w-[1340px] 2xl:mx-auto 2xl:px-0">
              {children}
            </div>
          </ViewProvider>
        </PropertyListPageLayout>
      </div>
      {footerChildren}
    </>
  );
};
